// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 29) return "static/js/dd2fc919f61e00e73f65.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"fd7a34c81a7780ae5303","122":"f798538655df3b606f47","123":"37b83c5cdabd4dcbe373"}[chunkId] + ".chunk.js";
};